/**
 * Store pour la gestion de la configuration (tâche en urgence, nombre de crédits alloué à l'inscription)
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from '@js/tools/axios';

export const useConfigurationStore = defineStore('configuration', (() => {

    // State de la configuration chargée
    const data = ref(null);

    /**
     * Retourne la configuration de la clé en paramètre
     * @param string key
     * @return mixed|null
     */
    const getValueById = computed(() => {
        return ((key) => {
            if(data.value === null) {
                return null;
            }

            const configuration = data.value.filter((currentConfiguration) => currentConfiguration.key === key).at(0)
            return (configuration || null);
        });
    });

    /**
     * Chargement de la configuration
     * @return Promise
     */
    const loadConfiguration = (() => {

        if(data.value !== null) {
            return Promise.resolve();
        }

        const path = '/api/configuration';

        return axios.get(path).then((response) => {
            if(response && response.data && response.data.success && response.data.configuration) {
                data.value = response.data.configuration;
                return Promise.resolve();
            }
            return Promise.reject();
        });

    });

    /**
     * Mise à jour de la valeur de la configuration dans le store
     * @param object newConfiguration
     * @return void
     */
    const setConfigurationValue = ((newConfiguration) => {
        if(data.value === null) {
            data.value = [];
        }

        const index = data.value.findIndex((currentConfiguration) => currentConfiguration.key === newConfiguration.key);
        if(index === -1) {
            data.value.push(newConfiguration);
        } else {
            data.value[index] = { ...newConfiguration };
        }
    });


    return {
        getValueById,
        loadConfiguration,
        setConfigurationValue
    };
}));
